const s = {
  name: "Gaming",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8,30v-3h2v3h3v2h-3v3H8v-3H5v-2H8z"/>
		<path class="st0" d="M21.5,33.7c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2
			C20.3,33.2,20.8,33.7,21.5,33.7z"/>
		<path class="st0" d="M25.8,29.5c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2
			C25.2,28.2,25.8,28.8,25.8,29.5z"/>
		<path class="st0" d="M0,0v40h23c5,0,9-4,9-9V0H0z M5,2v22h22V2h3v29c0,3.9-3.1,7-7,7H2V2H5z M25,2v20H7V2H25z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Gaming
};
